import { Action, createReducer, on } from "@ngrx/store";

import { Menu } from "@hermes/api-model-menu";

import {
    fetchMenuFromDiscovery,
    fetchMenuFromDiscoveryFailure,
    fetchMenuFromDiscoverySuccess,
} from "../actions/menu-alternative.action";

import { flattenMenuToCategoriesFromDiscovery } from "../helpers/categories-alternative.helper";
import {
    extractLinksFromAboutEntriesFromDiscovery,
    extractLinksFromMenuEntriesFromDiscovery,
} from "../helpers/entry-alternative.helper";
import { FlatDiscoveryCategories, MenuLink } from "../model/menu.model";

export const menuDiscoveryFeatureKey = "menu_discovery";

export interface StateForDiscovery {
    entry: Menu | undefined;
    categories: FlatDiscoveryCategories | undefined;
    links: MenuLink[] | undefined;
    pending: boolean;
}

export const initialDiscoveryState: StateForDiscovery = {
    entry: undefined,
    categories: undefined,
    links: undefined,
    pending: false,
};

const menuReducerForDiscovery = createReducer(
    initialDiscoveryState,
    on(fetchMenuFromDiscovery, fetchMenuFromDiscoveryReducer),
    on(fetchMenuFromDiscoverySuccess, fetchMenuFromDiscoverySuccessReducer),
    on(fetchMenuFromDiscoverySuccess, extractCategoriesFromDiscoveryReducer),
    on(fetchMenuFromDiscoveryFailure, fetchMenuFromDiscoveryFailureReducer),
);

export function reducerForDiscovery(
    state: StateForDiscovery | undefined,
    action: Action,
): StateForDiscovery {
    return menuReducerForDiscovery(state, action);
}

export function fetchMenuFromDiscoveryReducer(
    state: StateForDiscovery,
    _action: ReturnType<typeof fetchMenuFromDiscovery>,
): StateForDiscovery {
    return {
        ...state,
        pending: true,
    };
}

export function fetchMenuFromDiscoverySuccessReducer(
    state: StateForDiscovery,
    action: ReturnType<typeof fetchMenuFromDiscoverySuccess>,
): StateForDiscovery {
    const extractMenuEntries = extractLinksFromMenuEntriesFromDiscovery(
        action.entry.mainMenu,
    );

    const extractAboutEntries = extractLinksFromAboutEntriesFromDiscovery(
        action.entry.aboutMenu,
    );

    const mergedLinks = [...extractMenuEntries, ...extractAboutEntries];

    return {
        ...state,
        entry: action.entry,
        links: mergedLinks,
        pending: false,
    };
}

export function fetchMenuFromDiscoveryFailureReducer(
    state: StateForDiscovery,
    _action: ReturnType<typeof fetchMenuFromDiscoveryFailure>,
): StateForDiscovery {
    return {
        ...state,
        pending: false,
    };
}

export function extractCategoriesFromDiscoveryReducer(
    state: StateForDiscovery,
    action: ReturnType<typeof fetchMenuFromDiscoverySuccess>,
): StateForDiscovery {
    return {
        ...state,
        categories: flattenMenuToCategoriesFromDiscovery(action.entry.mainMenu),
    };
}
